import { Injectable } from "@angular/core";
import { User } from "../model/user.model";
import { StorageService } from "./storage.services";

@Injectable({
  providedIn: "root",
})
export class UserService {
  user: User;

  constructor(private _storage: StorageService) {}

  /**
   *
   * @param user
   * @param storageReady usado para indicar que el usuario ya esta en el local storage,
   * por lo que no es necesario guardarlo nuevamente.
   */
  setUser(user, storageReady?) {
    console.log("Setting user");
    console.log({ user, storageReady });
    this.user = user;
    let date = new Date();
    // Solo ponemos la fecha si no existe
    if (this.user && !this.user.loginDate) {
      this.user.loginDate = date.toString();
    }

    if (!storageReady) this._storage.guardar_storage("User", user);
  }

  logOut() {
    this.setUser(null);
  }

  getUser() {
    if (this.user) {
      return this.user;
    } else {
      this._storage
        .cargar_storage("User")
        .then((result) => {
          // Solo lo tomamos como valido si tiene token, email y fecha de login
          if (result["token"] && result["loginDate"] && result["email"]) {
            this.setUser(result, true);
            return this.user;
          } else {
            this.logOut();
            return null;
          }
        })
        .catch((err) => {
          console.log({ err });
          return null;
        });
    }
  }

  loadUser() {
    this._storage
      .cargar_storage("User")
      .then((result) => {
        // Cargamos el usaurio en memoria
        this.setUser(result, true);
      })
      .catch((err) => {
        console.log({ err });
      });
  }

  setToken(token) {
    this.user.token = token;
  }

  getToken(): string {
    if (this.user) return this.user.token;
  }

  userLoaded(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.user && this.user.token) {
        console.log("User already loaded");
        console.log(this.user);
        resolve(true);
      } else {
        console.log("Loading user");
        this._storage
          .cargar_storage("User")
          .then((result) => {
            if (
              result &&
              result["token"] &&
              result["loginDate"] &&
              result["email"]
            ) {
              console.log("User loaded from storage");
              console.log(result);
              this.setUser(result, true);
              resolve(true);
            } else {
              this.logOut();
              resolve(false);
            }
            resolve(true);
          })
          .catch((err) => {
            console.log({ err });

            resolve(false);
          });
      }
    });
  }

  isManagment(): boolean {
    let isAdmin;
    let role;
    if (this.user) {
      // Localizamos el rol que tenga asignado este componente
      role = this.user.roles?.find((rol) => {
        if (rol.component == "LeadComponent") return rol;
      });
      // Localizamos el accesso de administrador
      isAdmin = role?.access.find((adm) => {
        if (adm.name == "LeadAdmin" && adm.write == true) {
          return adm;
        }
      });
    }
    // Is Admin
    if (isAdmin) return true;
    else return false;
  }
}
